const SubAbas = [
  { label: 'Fornecedores', rota: '/daf/fornecedores/fornecedores' },
  { label: 'FAQ', rota: '/daf/fornecedores/faq' },
];

export default SubAbas;
